import React from 'react';
import styles from './Footer.module.css';
import XIcon from '../../assets/images/x.svg'; // coloca x.svg en src/assets si no está ahí

import facebook from '../../assets/images/facebook.svg';
import tiktok from '../../assets/images/t.svg'; // t.svg usado como TikTok
import instagram from '../../assets/images/I.svg';
import youtube from '../../assets/images/y.svg';
import web from '../../assets/images/w.svg';
import telegram from '../../assets/images/m.svg';
import whatsapp from '../../assets/images/w18.svg';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <nav className={styles.navigationSection}>
          <div className={styles.navigationTitle}>Navegación</div>
          <div className={styles.navigationLists}>
            <ul>
              <li>Inicio</li>
              <li>Acerca de</li>
              <li>Blog</li>
              <li>Servicio</li>
            </ul>
            <ul>
              <li>Producto</li>
              <li>Características</li>
            </ul>
          </div>
        </nav>

        <section className={styles.contactSection}>
          <div className={styles.socialGroups}>
            <div>
              <div className={styles.socialLabel}>Síguenos</div>
              <div className={styles.socialIcons}>
                <img src={facebook} alt="Facebook" />
                <a
                  href="https://www.instagram.com/r4conecta/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagram} alt="Instagram" />
                </a>
                <img src={XIcon} alt="X" className={styles.socialImg} />
                <a
                  href="https://www.youtube.com/@r4conecta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={youtube} alt="YouTube" />
                </a>
                <span className={styles.tiktokInline}>
                  <img src={tiktok} alt="TikTok" />
                  <span className={styles.tiktokHandle}>@r4conecta</span>
                </span>
              </div>
            </div>

            <div
              /* asegura que la etiqueta quede encima de los iconos */
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}
            >
              <div className={styles.webContainer}>
                <div className={styles.webBox}>
                  <div className={styles.webLabel}>Web</div>
                  <a
                    href="https://r4conecta.io/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.webLink}
                  >
                    <img src={web} alt="Web" className={styles.webIcon} />
                    
                  </a>
                </div>
                <span className={styles.webText}>r4conecta.io</span>
              </div>
            </div>
          </div>

          <div className={styles.contactInfo}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
              <div className={styles.socialLabel}>Contáctanos</div>
              <div className={styles.socialIcons}>
                <img src={telegram} alt="Telegram" />
                <div className={styles.whatsappItem}>
                  <img src={whatsapp} alt="WhatsApp" className={`${styles.contactIcon} ${styles.wIcon}`} loading="lazy" />
                  <span className={styles.phone}>+58 4123463875</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
}

export default Footer;

